import { render, staticRenderFns } from "./basket-notifications-handler.vue?vue&type=template&id=1294e7be&"
import script from "./basket-notifications-handler.vue?vue&type=script&lang=js&"
export * from "./basket-notifications-handler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports